import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CMSPortalEndpoints {

    constructor(@Inject(`ID_SITE`) public _idSite: string,
                @Inject(`ID_SETOR`) public _idSetor: string) {
    }

    cadastrobasico_getESM(): string {
        return '/cadastrobasico/setor/getESM';
    }

    bancoimagem_recuperaUltimaLogoPublicada(): string {
        return `/bancoimagem/recuperaUltimaLogoPublicada/${this._idSetor}`;
    }

    bancoimagem_recuperaImagemBase64(idImagem: string): string {
        return `/bancoimagem/recuperaImagemBase64/${idImagem}`;
    }

    bancoimagem_recuperaDestaqueImagem(max: Number): string {
        return `/bancoimagem/recuperaDestaqueImagem/${this._idSetor}?max=${max}`;
    }

    bancoimagem_recuperaVideos(): string {
        return `/videoService/recuperaVideos/${this._idSetor}`;
    }

    bancoimagem_recuperaVideo(idVideo: string): string {
        return `/videoService/recuperaVideo/${idVideo}`;
    }

    site_buscarMenu(): string {
        return `/site/buscarMenuSite/${this._idSite}`;
    }

    site_buscarPagina(idPagina: string): string {
        return `/site/buscarPagina/${this._idSite}/${idPagina}`;
    }

    site_efetuarPesquisa(): string {
        return `/site/efetuarBusca`;
    }

    divulgacao_buscarSlideNoticias(): string {
        return `/divulgacao/noticia/buscarSlideNoticias/${this._idSetor}/N`;
    }

    divulgacao_buscarDestaquesNoticias(): string {
        return `/divulgacao/noticia/buscarDestaquesNoticias/${this._idSetor}/N`;
    }

    divulgacao_listarNoticia(): string {
        return `/divulgacao/noticia/buscarNoticias/${this._idSetor}/N`;
    }

    divulgacao_buscarNoticia(idPagina: string): string {
        return `/divulgacao/noticia/buscarNoticia/${idPagina}/${this._idSetor}`;
    }

    divulgacao_buscarUltimaNoticias(): string {
        return `/divulgacao/noticia/buscarUltimaNoticias/${this._idSetor}/S`;
    }

    eventos_buscarEventos(): string {
        return `/cadastro/eventos/buscarEventos/${this._idSetor}`;
    }

    eventos_buscarEvento(idEvento: string): string {
        return `/cadastro/eventos/buscarEvento/${idEvento}`;
    }

    eventos_buscarSlideEventos(): string {
        return `/cadastro/eventos/buscarSlideEventos/${this._idSetor}`;
    }

    formulario_buscarEnquete(): string {
        return `/formulario/formulario/buscarEnquete/${this._idSetor}`;
    }

    formulario_salvarPerguntaEnquete(): string {
        return `/formulario/formulario/salvarEnquete`;
    }

    formulario_buscarResultadoPerguntaEnquete(idSecao: string): string {
        return `/formulario/formulario/recuperarResultadoEnquete/${idSecao}`;
    }

}
